import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { PopupNotificationsService } from '../popup-notifications.service';
import { PopupNotificationComponent } from '../popup-notification/popup-notification.component';

@Component({
  selector: 'pr-popup-notifications',
  templateUrl: './popup-notifications.component.html',
  styleUrl: './popup-notifications.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    PopupNotificationComponent,
  ],
})
export class PopupNotificationsComponent {
  constructor(public notifications: PopupNotificationsService) {}

  clearAll(): void {
    void this.notifications.clearAllNotifications();
  }
}
